exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".friend-button[data-v-245483ef]{cursor:pointer}.friend-button img[data-v-245483ef]{display:block;width:100px;height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-245483ef","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/partials/FriendButton.vue
// module id = +D2F
// module chunks = 0